import { useMutation, useQueryClient } from 'react-query';
import api from 'api';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
export const useAnamnesisMutation = () => {
  const client = useQueryClient();
  const personReferenceId = usePersonId();
  return useMutation(({
    formData,
    signatureEncoded,
    clinicReferenceId
  }) => api.ana.postAnamnesis({
    personReferenceId,
    formData,
    signatureEncoded,
    clinicReferenceId
  }), {
    onSuccess: () => {
      client.invalidateQueries(['anamnesis_listing', personReferenceId]);
      client.invalidateQueries(['optins', personReferenceId]);
    }
  });
};